import React from 'react';
import { motion } from 'framer-motion';

export const ComingSoonBanner = () => {
  return (
    <motion.div 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="bg-ink text-white py-2 px-4 text-center relative z-[60] border-b border-white/10"
    >
      <p className="text-xs md:text-sm font-medium tracking-wide flex items-center justify-center gap-2">
        <span className="w-2 h-2 rounded-full bg-mint animate-pulse"></span>
        Curve for iOS & Android is launching Spring 2024. 
        <span className="hidden sm:inline opacity-60">Join the waitlist to be first in line.</span>
      </p>
    </motion.div>
  );
};